import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'

import { ReactComponent as Op36Logo } from '../assets/images/logos/horizontal-logo.svg'
import backgroundVideo from './../assets/videos/welcome-page-background-video.mp4'
import backgroundVideoPoster from './../assets/images/welcome-page-background-video-poster.webp'
import { buildStateFromParams } from '../constants/oauth'
import { fetchIdpSignUpUrl, redirectToIdpLogin } from '../actions/authActions'
import ButtonLink from './common/buttons/ButtonLink'
import buttonLinkStyles from './common/buttons/ButtonLink.module.scss'
import SignUpSegmentSelector from './auth/common/SignUpSegmentSelector'

import classes from './WelcomePage.module.scss'

const WelcomePage = ({ showSignUp = false }) => {
  const communityId = localStorage.getItem('communityId')
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const location = useLocation()

  const handleSignIn = (e) => {
    e.preventDefault()
    redirectToIdpLogin(searchParams).catch(() => navigate('/login/legacy'))
  }

  const handleSignUp = (segment) => {
    fetchIdpSignUpUrl()
      .then(url => {
        const state = buildStateFromParams(segment, communityId, searchParams)
        window.location.href = `${url}&state=${encodeURIComponent(state)}`
      })
      .catch(() => toast.error('Sign up is currently unavailable.'))
  }

  const handleIndividualSignUp = () => handleSignUp('individual')
  const handleFamilySignUp = () => handleSignUp('family')

  return (
    <main className={classNames(classes.welcomePage, { [classes.selectorMode]: showSignUp })}>
      <section className={classNames(classes.actionPanel, 'd-flex flex-column align-items-center')}>
        <div className={classNames(classes.formContainer, 'd-flex flex-column align-items-center')}>
          <Op36Logo className={classes.op36Logo} />
          <h2 className={classNames(classes.logoText, 'mt-3')}>The #1 Way To Learn To Play Golf</h2>

          {showSignUp ? (
            <SignUpSegmentSelector
              onIndividualClick={handleIndividualSignUp}
              onFamilyClick={handleFamilySignUp}
            />
          ) : (
            <>
              <button
                type='button'
                onClick={() => navigate({ pathname: '/create-account', search: location.search })}
                className={classNames(buttonLinkStyles['button-link'], buttonLinkStyles.orange, classes.actionLink, 'w-100 mt-4')}
              >
                Create an Account
              </button>

              <ButtonLink linkColor='white' navigateTo='#' onClick={handleSignIn} className={classNames(classes.actionLink, 'mt-3')} isExternal>
                Log In
              </ButtonLink>

              <p className={classNames(classes.poweredByText, 'my-3')}>
                Powered by{' '}
                <a href='https://www.golfgenius.com' target='_blank' rel='noreferrer' className={classes.poweredByLink}>
                  Golf Genius
                </a>
                {' '}secure login
              </p>
            </>
          )}
        </div>
      </section>

      <ToastContainer theme='colored' />

      <aside className={classes.heroPanel}>
        <div className={classes.heroPanelWrapper}>
          <video autoPlay loop muted poster={backgroundVideoPoster} className={classes.backgroundVideo}>
            <source src={backgroundVideo} type='video/mp4' />
          </video>

          <div className={classes.gradientOverlay} />
        </div>
      </aside>
    </main>
  )
}

WelcomePage.propTypes = {
  showSignUp: PropTypes.bool,
}

export default WelcomePage
